import YandexEcommerce from 'components/yandex/ecommerce';
import 'vendor/promise-polyfill.min';

/**
 * Компонент Utils
 */
function Utils() {
    const obj = this;

    const triggerList = [];

    /**
     * Объект страницы, для доступа из консоли
     */
    this.page = {
        images: {},
    };

    /**
     * Прослойка для $(document).on(events, selector, handler);
     */
    this.addTrigger = function(events, selector, handler = null) {
        if (events === null || selector === null
            || typeof events === 'undefined' || typeof selector === 'undefined') {
            throw new Error('Некорректный вызов метода');
        }

        const eventsList = events.split(' ');
    
        // короткий вызов
        if (handler === null) {
            handler = selector;
    
            // handler передается 2 аргументом
            if (typeof handler !== 'function') {
                throw new Error('handler не является функцией');
            }
    
            switch(events) {
                case 'resize':
                    let cachedWidth = window.visualViewport.width;
                    let otherHandler = handler;
    
                    handler = function() {
                        let newWidth = window.visualViewport.width;
                        if (newWidth !== cachedWidth) {
                            otherHandler();
                            cachedWidth = newWidth;
                        }
                    }
    
                    selector = window;
                    break;
                case 'scroll':
                case 'popstate':
                    selector = window;
                    break;
                case 'keyup':
                case 'click':
                case 'submit':
                case 'mouseup':
                    selector = document;
                    break;
                case 'ready':
                    selector = document;
                    selector.addEventListener('DOMContentLoaded', event => {
                        handler.call(selector, event);
                    });
                    break;
                default:
                    throw new Error('Events не найден');
                    break;
            }
    
            eventsList.forEach(eventType => {
                selector.addEventListener(eventType, event => {
                    handler.call(selector, event);
                });
            });
    
            // $selector.on(events, handler);
            triggerList.push({
                events: events,
                $selector: selector,
                handler: handler,
                token: obj.md5(events.toString() + selector.toString() + handler.toString()),
            });
    
            return;
        }
    
        if (typeof handler !== 'function') {
            throw new Error('handler не является функцией');
        }
    
        // вызов по умолчанию
        if (typeof selector == 'object' && selector.selector) {
            selector = selector.selector;
        }
    
        eventsList.forEach(eventType => {
            document.addEventListener(eventType, function(event) {
                if (!selector) {
                    return handler.call(event.target, event);
                }

                if (selector === document || selector === window) {
                    return handler.call(selector, event);
                }

                if (typeof selector !== 'string') {
                    if (selector.length) {
                        selector = '.' + Array.prototype.join.call(selector[0].classList, '.');
                    } else if (!(selector instanceof NodeList)) {
                        selector = '.' + Array.prototype.join.call(selector.classList, '.');
                    }
                }

                let $element = event.target.closest && event.target.closest(selector);
                if ($element) {
                    handler.call($element, event);
                }
            });
        });
    
        triggerList.push({
            events: events,
            selector: selector,
            handler: handler,
            token: obj.md5(events.toString() + selector.toString() + handler.toString()),
        });
    }

    /**
     * Липкие элеметы
     */
    this.stickInParent = (element, offsetTop = 0) => {
        var stickyElement = element;
        var parentElement = stickyElement.parentElement;
        var stickyInitialSize = {
            width:  stickyElement.offsetWidth,
            height: stickyElement.offsetHeight,
        };
    
        function updateSticky() {
            var scrollTop = window.pageYOffset;
            var stickyOffsetTop = stickyElement.getBoundingClientRect().top + offsetTop;
    
            if (scrollTop > stickyOffsetTop) {
                stickyElement.style.position = 'fixed';
                stickyElement.style.top = `${offsetTop}px`;
                stickyElement.style.width = stickyInitialSize.width + 'px';
                parentElement.style.paddingTop = stickyElement.offsetHeight + 'px'; // Ensure content doesn't jump
            } else {
                stickyElement.style.position = 'relative';
                parentElement.style.paddingTop = '0';
                stickyElement.style.top = 0;
            }
        }
    
        window.addEventListener('scroll', updateSticky);
        window.addEventListener('resize', function() {
            updateSticky();
        });
    }

    /**
     * Удаляем триггер
     */
    this.removeTrigger = function(events, selector, handler = null) {
        // короткий вызов
        if (handler === null) {
            switch(events) {
                case 'resize':
                case 'scroll':
                case 'popstate':
                    selector = window;
                    break;
                case 'ready':
                case 'keyup':
                case 'mouseup':
                case 'click':
                    selector = document;
                    break;
            }

            // handler передается 2 аргументом
            handler = selector;
        }

        const md5Event = obj.md5(events.toString() + selector.toString() + handler.toString());
        // ищем тригер и отписываемся
        triggerList.filter(trigger => {
            if (trigger.token === md5Event) {
                let currentEvents = trigger.events.split(' ');

                currentEvents.forEach(eventType => {
                    document.removeEventListener(eventType, trigger.handler);
                });

                return false;
            }

            return true;
        });
    }

    /**
     * Получаем список тригерров
     */
    this.getTriggers = function() {
        return triggerList;
    }

    /**
     * Кастомные события
     */
    window.triggerSubscribers = typeof window.triggerSubscribers === 'object' ? window.triggerSubscribers : [];

    /**
     * Вызов события по подписке
     */
    this.triggerEvent = (event_name, ...data) => {
        window.triggerSubscribers = typeof window.triggerSubscribers === 'object' ? window.triggerSubscribers : [];
    
        // инициализируем
        window.triggerSubscribers[event_name] = window.triggerSubscribers[event_name] || {
            triggered: false,
            data: {},
            callbacks: []
        };
    
        // отмечаем вызов и сохраняем данные
        window.triggerSubscribers[event_name].triggered = true;
        window.triggerSubscribers[event_name].data = data;
    
        // вызываем всех
        let result;
        window.triggerSubscribers[event_name].callbacks.filter(callback => {
            return !callback.triggered;
        }).forEach(callback => {
            result = callback.callback.apply(null, data);
    
            // ставим true если нужно вызвать 1 раз
            callback.triggered = !callback.options.multiple;
        });
    
        return result;
    }

    /**
     * Подписка на событие
     */
    this.subscribeEvent = function(event_name, callback, options = {}) {
        if (typeof callback != 'function') {
            return false;
        }

        // инициализируем
        window.triggerSubscribers[event_name] = window.triggerSubscribers[event_name] || {
            triggered: false,
            data: {},
            callbacks: []
        };

        // добавляем в стек
        window.triggerSubscribers[event_name].callbacks.push({
            triggered: false,
            callback,
            options: {
                multiple: options.multiple || true,
            }
        });

        // если вызов уже был (поздно подписались, то вызываем)
        if (window.triggerSubscribers[event_name].triggered) {
            obj.triggerEvent(event_name, window.triggerSubscribers[event_name].data)
        }
    }

    // получаем список подписок и событий
    this.getTriggerSubscribers = function() {
        return window.triggerSubscribers;
    }

    /**
     * Преимущества ПриветТур
     * @required slick
     */
    this.mainAdvantages = function($container) {
        fetch('/main/ajax_main_advantages/', {
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            }
        })
            .then(response => response.json())
            .then(r => {
                $container.insertAdjacentHTML('afterend', r.content);
                $container.remove();

                import('vendor_components/swiper.min')
                    .then(({default: Swiper}) => {
                        new Swiper('.Advantages__list', {
                            slidesPerView: 1,
                            speed: 300,
                            pagination: {
                                el: '.Advantages__pagination',
                                clickable: true,
                                bulletElement: 'div',
                                bulletClass: 'Advantages__bullet',
                                bulletActiveClass: 'Advantages__bullet--active',
                                type: 'bullets',
                            },
                        });
                    })
                    .catch(() => console.log('An error occurred while loading the component'));
            });
    }
    this.subscribeEvent('mainAdvantages', this.mainAdvantages)

    /**
     * Обновляем счетчик для сердечка избранного
     */
    this.updateFavorites = function (count) {
        const $counters = document.querySelectorAll('.Header__favorite, .Favorites--count, .js-favoriteCounter');

        $counters.forEach($counter => {
            $counter.removeAttribute('data-after');
        });

        if (count) {
            $counters.forEach($counter => {
                $counter.setAttribute('data-after', count);
            });
        }
    }

    /**
     * Форматирование строки денег
     */
    this.formatMoney = function(n, c, d, t) {
        var c = isNaN(c = Math.abs(c)) ? 2 : c,
        d = d == undefined ? "." : d,
        t = t == undefined ? "," : t,
        s = n < 0 ? "-" : "",
        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
        j = (j = i.length) > 3 ? j % 3 : 0;

        return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t);
    };

    /**
     * Форматирование строки денег
     */
    Number.prototype.formatMoney = function(x, y, z) {
        return obj.formatMoney(this, x, y, z);
    }

    /**
     * Асинхронная загрузка скриптов
     */
    this.loadScript = function(url) {
        if (Array.isArray(url)) {
            let self = this;
            let prom = [];
            url.forEach(function (item) {
                prom.push(self.script(item));
            });
            return Promise.all(prom);
        }

        return new Promise(function (resolve, reject) {
            let r = false;
            let t = document.getElementsByTagName('script')[0];
            let s = document.createElement('script');

            s.type = 'text/javascript';
            s.src = url;
            s.async = true;
            s.onload = s.onreadystatechange = function () {
                if (!r && (!this.readyState || this.readyState === 'complete')) {
                    r = true;
                    resolve(this);
                }
            };
            s.onerror = s.onabort = reject;
            t.parentNode.insertBefore(s, t);
        });
    }

    /**
     * Глобальный обработчик ошибок
     */
    window.addEventListener('error', function(e) {
        obj.error(e);
    });

    this.formData = (args) => {
        const formData = new FormData();
    
        for (const p in args) {
            if (args.hasOwnProperty(p)) {
                formData.append(p, args[p]);
            }
        }
    
        return formData;
    }

    this.error = (e) => {
        const data = {
            'error_message': e.message,
            'file': e.filename,
            'line_number': e.lineno,
            'column_number': e.colno,
            'location': window.location.href,
            'screen_height': window.visualViewport.height,
            'screen_width': window.visualViewport.width,
        };
    
        if (e.error && e.error.stack) {
            data['stack'] = e.error.stack;
        }
    
        if (data.error_message == 'ResizeObserver loop limit exceeded'
            || data.error_message == 'Uncaught EvalError: Possible side-effect in debug-evaluate') {
            return;
        }
    
        console.error(e);
    
        const formData = new FormData();
        for (const [key, value] of Object.entries(data)) {
            formData.append(key, value);
        }
    
        obj.delay(() => {
            fetch('/main/js_error_handler/', {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: formData,
            });
        }, 500);
    }

    /**
     * Ставим многоточие
     */
    this.jsDots = (filterCount = 0) => {
        // страницы с фильтрами
        if (filterCount > 0) return false;
    
        const $dots = document.querySelectorAll('.js-dots:not(.js-initializaded)');
        if ($dots.length > 0) {
            $dots.forEach(($item) => {
                const $tagList = $item.querySelectorAll('li');
                let classes = '';
                let sum = 0,
                    dots = 28,
                    padding = 23,
                    width = $item.offsetWidth;
    
                // не удалось получить ширину
                if (width === 0 || $tagList.length === 0) {
                    return true;
                }
    
                // считаем
                $tagList.forEach(($tag) => {
                    const w = $tag.offsetWidth + padding;
                    if (width - dots < sum + w) {
                        $tag.remove();
                    } else {
                        sum += w;
                    }
    
                    classes = $tag.getAttribute('class');
                });
    
                $item.classList.add('js-initializaded');
    
                // добавляем точки
                const $div = document.createElement('div');
                $item.appendChild($div);
                $div.outerHTML = `<li class="${classes}">...</li>`;
            });
        }
    }

    /**
     * Включен debug
     */
    this.hasDebug = function() {
        return document.cookie.indexOf('debug=1') !== -1;
    }

    /**
     * Время генерации страницы
     */
    this.pageGenerateTime = () => {
        if (document.cookie.indexOf('debug=1') !== -1) {
            const debug = {
                generateTime: document.body.dataset.generate_time || Date(),
                version: document.body.dataset.version || '',
                pageSubscribers: window.triggerSubscribers || {},
                pageTriggers: window.triggerList || {}
            };
    
            if(document.readyState !== 'loading') {
                console.log(debug);
            } else {
                window.addEventListener('DOMContentLoaded', () => console.log(debug));
            }
        }
    }

    /**
     * Версия сайта
     */
    this.version = function() {
        return document.body.dataset.version || '';
    }

    /**
     * JS обработчик кликла по ссылки, замена <a>
     * window сделан чтобы работал вызов с html элементов
     */
    window.jsLink = this.jsLink = (url, target, elem, callback) => {
        if (!url) return false;
    
        let phone = /^tel:/
        let http = /^http/
        let social = /^(skype|viber|whatsapp)/
        let origin = window.location.origin;
    
        // если ссылка телефон
        if (phone.test(url)) {
            const classText = elem.classList.contains('Phone') ? 'class="Phone"' : '';
    
            let parent = elem.parentNode,
                tempDiv = document.createElement('div');
                tempDiv.innerHTML = `<a href="${url}" ${classText}>${elem.textContent}</a>`;
    
            var input = tempDiv.childNodes[0];
    
            parent.replaceChild(input, elem);
    
            return false;
        }
    
        // если ссылка social
        if (social.test(url) && elem) {
            window.location.href = decodeURI(url);
            return false;
        }
    
        // проверка на формат ссылки
        if (!http.test(url) && !social.test(url)) {
            url = origin + url;
        }
    
        // пытаемся отловить событие клика
        var e = window.event;
        var btnCode = -1;
        if ('object' === typeof e) {
            btnCode = e.button;
        }
    
        // не клик
        switch (btnCode) {
            case -1: // firefox
            case 0: // клик левой кнопкой
                if (typeof callback === 'function') {
                    callback();
                }
                if (target === '_blank') {
                    window.open(url, '_blank');
                } else {
                    window.location.href = url;
                }
                break;
            case 1: // клик колесиком
                window.open(url, '_blank');
                break;
        }
    
        return false
    }

    /**
     * Кнопка наверх
     */
    this.activateScrollUpButton = () => {
        return; // кнопка отключена 2024-12-04

        const backButton = document.querySelector('.js-button-back');
        if (backButton === null) {
            return;
        }
    
        function activeButtonBack() {
            const scrollHeight = window.pageYOffset;
    
            if (scrollHeight > 500) {
                backButton.classList.add('is-active');
            } else {
                backButton.classList.remove('is-active');
            }
        }
    
        backButton.addEventListener('click', function(e) {
            e.preventDefault();
    
            window.scrollTo({top: 0, behavior: 'smooth'});
        });
    
        var scrollTimeout;
    
        const callback = function() {
            if (scrollTimeout) {
                clearTimeout(scrollTimeout);
                scrollTimeout = null;
            }
            scrollTimeout = setTimeout(activeButtonBack, 50);
        }
    
        window.addEventListener('resize', activeButtonBack);
        window.addEventListener('scroll', activeButtonBack);
    }

    /**
     * Чекбоксы в виде звезд
     */
    this.startCheckbox = function() {
        obj.addTrigger('mouseenter', '.js-checkbox-star', function(e) {
            var indexItem = Array.prototype.indexOf.call(this.parentNode.children, this);

            this.parentNode.classList.add('active-star-' + indexItem);
        });

        obj.addTrigger('mouseleave', '.js-checkbox-star', function(e) {
            this.parentNode.classList.add('Form__checkbox-star-list');
        });

        obj.addTrigger('click', '.js-checkbox-star label', function(e) {
            e.preventDefault();

            var parentBlock = this.closest('.Form__checkbox-star-list');
            var indexStar = Array.prototype.indexOf.call(this.parentNode.parentNode.children, this.parentNode) + 1;

            // Сбрасываем ранее выбранное кол-во звезд
            parentBlock.querySelector('.js-checkbox-star .js-checkbox-item-star').checked = false;

            if (parentBlock.getAttribute('data-selected-star') == indexStar) {
                return false;
            } else {
                parentBlock.getAttribute('data-selected-star', indexStar);

                for (var i = 0; i < indexStar; i++) {
                    parentBlock.querySelectorAll('.js-checkbox-star .js-checkbox-item-star')[i].checked = true;
                }
            }
        });
    }

    /**
     * Скроллим к элементу на странице
     */
    this.scrollTo = function(el, time = 250, offset_diff = 0) {
        const $el = document.querySelector(el);
        time = time ? time : 250;

        if (!$el) {
            throw new Error('Элемент для скролла не найден: ' + el);
        } else {
            function smoothScrollTo(endScrollTop, duration) {
                let startScrollTop = window.pageYOffset;
                let startTime = null;
            
                function animationStep(timestamp) {
                    if (!startTime) startTime = timestamp;
                    let progress = timestamp - startTime;
                    let percent = Math.min(progress / duration, 1);
                    let newScrollTop = startScrollTop + (endScrollTop - startScrollTop) * percent;
                    window.scrollTo(0, newScrollTop);
            
                    if (progress < duration) {
                        requestAnimationFrame(animationStep);
                    }
                }
            
                requestAnimationFrame(animationStep);
            }

            const targetScrollTop = $el.getBoundingClientRect().top + window.pageYOffset + offset_diff;

            // Плавно скроллим к целевой позиции
            smoothScrollTo(targetScrollTop, time);
        }
    }

    /**
     * Функция для отложенного вызова другой функции
     */
    this.throttle = function(func, timeout) {
        let inThrottle = false;

        return function() {
            const args = arguments;
            const context = this;

            if (!inThrottle) {
                inThrottle = true;
                func.apply(context, args);
                setTimeout(() => {
                    inThrottle = false;
                }, timeout);
            }
        };
    }

    /**
     * Установка/удаление cookie
     */
    this.setCookie = function(name, value, days) {

        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }

        var cookie = name + "=" + (value || "") + expires + "; path=/";
        var domainMatch = location.host.match(/privettur\.[a-z.]+$/);
        if (domainMatch) {
            cookie += "; domain=." + domainMatch[0];
        }
        document.cookie = cookie;
    }

    /**
     * Получаем cookie
     */
    this.getCookie = function(name) {
        var matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    /**
     * Отмечаем избранное
     */
    this.checkFavoriteList = () => {
        const favorite_list = obj.getCookie('favorite_list');
    
        document.querySelectorAll('.js-objectFavorite[data-id]').forEach($favorite => {
            const $icons = $favorite.querySelectorAll('svg');
    
            if ($icons.length > 1) {
                $icons[1].classList.add('fade-out');
            }
        });
        
        if (typeof favorite_list === 'undefined') return;
        const hotel_list = JSON.parse(favorite_list).map(id => parseInt(id, 10));
    
        // отмечаем
        document.querySelectorAll('.js-objectFavorite[data-id]').forEach((el) => {
            const hotel_id = parseInt(el.dataset.id, 10);
            const $icons = el.querySelectorAll('svg');
    
            if (hotel_list.indexOf(hotel_id) > -1) {
                el.classList.add('active');
    
                if ($icons.length > 1) {
                    $icons[1].classList.replace('fade-out', 'fade-in-reduce');
                }
            }
        })
    
        // обновляем счётчик избранного
        obj.updateFavorites(hotel_list.length);
    }

    /**
     * Ставим куку поддержки webp или нет
     */
    this.setWebpSupportCookie = () => {
        let elem = document.createElement('canvas');
        let support = false;
    
        if (!!(elem.getContext && elem.getContext('2d'))) {
            // was able or not to get WebP representation
            support = elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
        }
    
        if (support === true) {
            obj.setCookie('webp_support', 1, 365);
        } else {
            obj.setCookie('webp_support', 0, 365);
        }
    
        // very old browser like IE 8, canvas not supported
        return support;
    }

    /**
     * Определяем поддержку webp по кукам
     */
    this.hasWebpSupport = function() {
        // нет куки, проверяем поддержку webp
        if (typeof webp_support === 'undefined') {
            obj.setWebpSupportCookie();
        }

        if (obj.getCookie('webp_support') === '1') {
            return true;
        }

        return false;
    }

    /**
     * LazyLoad для css
     */
    this.lazyClass = function($element) {
        $element = typeof $element === 'undefined' ? document.querySelectorAll('.js-lazyClass') : $element;
        const lazyClassOne = ($item) => {
            if (obj.hasWebpSupport()) {
                $item.classList.add('webp');
            } else {
                $item.classList.add('original');
            }
        }
    
        // массив
        if (typeof $element.length !== 'undefined') {
            $element.forEach($item => lazyClassOne($item));
        } else {
            lazyClassOne($element);
        }
    }

    /**
     * LazyLoad для css
     */
    this.lazyBlock = ($element) => {
        $element = typeof $element === 'undefined' ? document.querySelectorAll('.js-lazyBlock') : $element;
        const lazyBlockOne = ($item) => {
            // для отработки только 1 раз
            $item.classList.remove('js-lazyBlock');
    
            const callback = $item.dataset.callback;
    
            // есть callback
            if (callback) {
                // для отработки только 1 раз
                $item.dataset.callback = '';
    
                obj.triggerEvent(callback, $item);
            }
        }
    
        // массив
        if (typeof $element.length !== 'undefined') {
            $element.forEach($item => lazyBlockOne($item));
        } else {
            lazyBlockOne($element);
        }
    }

    this.lazyFrame = ($element) => {
        $element = typeof $element === 'undefined' ? document.querySelectorAll('.js-lazyFrame') : $element;
        const lazyFrameOne = ($item) => {
            const frame     = $item.dataset.frame;
            const frameType = $item.dataset.frameType;
    
            if (frameType === 'html' && typeof frame === 'string' && frame.length > 0) {
                const $parent = $element.parentNode;
    
                const $div = document.createElement('div');
                $div.innerHTML = frame;
                const $iframe = $div.firstElementChild;
                $parent.appendChild($iframe);
    
                $iframe.addEventListener('load', () => {
                    $element.remove();
                    $iframe.style.display = '';
                });
            } else if (typeof frame === 'string' && frame.length > 0) {
                const $parent = $element.parentNode;
    
                const $div = document.createElement('div');
                $div.innerHTML = '<iframe src="' + frame + '" frameborder="0" allowfullscreen style="display: none;"></iframe>';
                const $iframe = $div.firstElementChild;
                $parent.appendChild($iframe);
    
                $iframe.addEventListener('load', () => {
                    $element.remove();
                    $iframe.style.display = '';
                });
            }
        }
    
        // массив
        if (typeof $element.length !== 'undefined') {
            $element.forEach($item => lazyFrameOne($item));
        } else {
            lazyFrameOne($element);
        }
    }

    /**
     * LazyLoad фоток
     */
    this.lazyLoad = ($container) => {
        // если контейнера нет, значит observer неподдерживается, поэтому грузим все
        if ($container === null || typeof $container === 'undefined') {
            obj.lazyClass();
            obj.lazyBlock();
            obj.lazyFrame();
        }
    
        // lazyClass
        if ($container.classList.contains('js-lazyClass')) {
            return obj.lazyClass($container);
        }
    
        // lazyBlock
        if ($container.classList.contains('js-lazyBlock')) {
            return obj.lazyBlock($container);
        }
    
        // lazyFrame
        if ($container.classList.contains('js-lazyFrame')) {
            return obj.lazyFrame($container);
        }
    
        if (obj.hasDebug() && typeof $container === null) {
            throw new Error('container не объявлен');
        }
    
        // fix slick copy init block
        $container.querySelectorAll(':not(img).js-lazyLoad.js-lazyLoadInit').forEach(($item) => {
            if ($item.querySelector('img') === null) {
                $item.classList.remove('js-lazyLoadInit');
            }
        });
    
        let $items = $container.querySelectorAll('.js-lazyLoad:not(.js-lazyLoadInit)');
    
        // есть ли смысл сортировать?
        if($items.length > 0 && $items[0].getAttribute('data-sort') !== null) {
            $items.sort(function(a, b) {
                return a.getAttribute('data-sort') > b.getAttribute('data-sort');
            });
        }
    
        // LazyLoad фоток
        $items.forEach($item => {
            const data = {
                src: $item.getAttribute('data-src'),
                srcset: $item.getAttribute('data-srcset'),
                webp_src: $item.getAttribute('data-webp-src'),
                webp_srcset: $item.getAttribute('data-webp-srcset'),
                alt: $item.getAttribute('data-alt'),
                style: $item.getAttribute('data-style'),
            };
            const imgAttr = {
                src: false,
                srcset: false,
                alt: false,
                style: false,
            };
    
            // отмечаем как просмотрено
            $item.classList.add('js-lazyLoadInit');
    
            // webp
            if (obj.hasWebpSupport()
                && typeof data.webp_src !== 'undefined'
                && /.*.webp/.test(data.webp_src)) {
    
                // src
                imgAttr.src = data.webp_src;
    
                // srcset
                if(typeof data.webp_srcset !== 'undefined' && /.*.webp/.test(data.webp_srcset)) {
                    imgAttr.srcset = data.webp_srcset;
                }
            } else {
                // src
                imgAttr.src = data.src;
    
                // srcset
                if (typeof $srcset !== 'undefined') {
                    imgAttr.srcset = data.srcset;
                }
            }
    
            // style
            if (data.style !== null && data.style.length > 0) {
                imgAttr.style = data.style;
            }
    
            // alt
            if (data.alt !== null && data.alt.length > 0) {
                imgAttr.alt = data.alt;
            }
    
            // загрузка Image последовательно
            if ($item.nodeName === 'IMG') {
                if (imgAttr.src) {
                    $item.setAttribute('src', imgAttr.src);
                }
    
                if (imgAttr.style) {
                    $item.setAttribute('style', imgAttr.style);
                }
    
                if (imgAttr.srcset) {
                    $item.setAttribute('srcset', imgAttr.srcset);
                }
    
                if (imgAttr.alt) {
                    $item.setAttribute('alt', imgAttr.alt);
                }
            } else {
                // ищем заглушку, если нет - создаём
                let $img = $item.querySelector('img');
                if ($img === null) {
                    $img = document.createElement('img');
                    $item.appendChild($img);
                }
    
                // применяем аттрибуты
                for (let field in imgAttr) {
                    if (imgAttr[field]) {
                        $img.setAttribute(field, imgAttr[field]);
                    }
                }
            }
    
            if ($item.classList.contains('js-removeStyle')) {
                $item.removeAttribute('style');
            }
        });
    
        // любые элементы со style
        $container.querySelectorAll('.js-lazyLoadBlock:not(.js-lazyLoadInit)').forEach($item => {
            const $style = $item.getAttribute('data-style');
            const $webp_style = $item.getAttribute('data-webp-style');
    
            // отмечаем как просмотрено
            $item.classList.add('js-lazyLoadInit');
    
            if(obj.hasWebpSupport()
                && typeof $webp_style !== 'undefined'
                && /.*.webp/.test($webp_style)) {
                $item.setAttribute('style', $webp_style);
                return true;
            }
    
            $item.setAttribute('style', $style);
        });
    }

    /**
     * Проверяем поддержку observer
     */
    this.hasObserverSupport = function() {
        let hasObserver = obj.getCookie('observer_support');

        // нет куки
        if (typeof hasObserver === 'undefined') {
            if (!'IntersectionObserver' in window ||
                !'IntersectionObserverEntry' in window ||
                !'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
                obj.setCookie('observer_support', 0, 365);
                return false;
            } else {
                obj.setCookie('observer_support', 1, 365);
                return true;
            }
        }

        return hasObserver == 1 ? true : false;
    }

    /**
     * Инициализация обсервера
     */
    this.initObserver = function() {
        if (obj.hasObserverSupport()) {
            // обсервер для lazyLoad
            const intersectionObserver = new IntersectionObserver(function(entries) {
                entries.forEach(function(item) {
                    if (item.isIntersecting === true) {
                        obj.lazyLoad(item.target);
                    }
                });
            });
    
            let containerList = [];
                containerList = Array.prototype.concat.apply(containerList, document.getElementsByClassName('js-lazyLoadContainer'));
                containerList = Array.prototype.concat.apply(containerList, document.getElementsByClassName('js-lazyClass'));
                containerList = Array.prototype.concat.apply(containerList, document.getElementsByClassName('js-lazyBlock'));
                containerList = Array.prototype.concat.apply(containerList, document.getElementsByClassName('js-lazyFrame'));
    
            for (let item of containerList) {
                if (item.classList.contains('js-initObserver')) {
                    continue;
                }

                item.classList.add('js-initObserver');

                intersectionObserver.observe(item);
            }
        } else {
            if(document.readyState !== 'loading') {
                obj.lazyLoad()
            } else {
                window.addEventListener('DOMContentLoaded', lazyLoad);
            }
        }
    }

    /**
     * Глобальный IntersectionObserver
     * @param  Array|NodeList|ObjectList options.elements Массив элементов
     * @param  Object                    options.options  Объект с опциями для IntersectionObserver (root, threshold, rootMargin)
     * @param  Function                  options.callback Функция которая вызывается после срабатывания
     */
    this.observe = function({elements, options, callback}) {

        if (typeof elements == 'undefined') {
            return false;
        }

        if (typeof elements == 'object' && elements.nodeType) {
            elements = [elements];
        }

        // по умолчанию вызывается lazyLoad
        if (typeof callback != 'function') {
            callback = function(elements) {
                elements.forEach(function(element) {
                    obj.lazyLoad(element);
                });
            }
        }

        // не поддерживается
        if (!obj.hasObserverSupport()) {
            callback(Array.from(elements));
            return false;
        }

        const observer = new IntersectionObserver(function(entries) {
            const intersected = entries.filter(function(entry) {
                return entry.isIntersecting;
            });

            intersected.forEach(function(entry) {
                observer.unobserve(entry.target);
            });

            if (intersected.length) {
                callback(intersected.map(function(entry) {
                    return entry.target;
                }));
            }
        }, options);

        // вешаем слушателя
        Array.from(elements).forEach(function(element) {
            observer.observe(element);
        });
    }

    /**
     * Отправляем просмотры
     */
    this.hotelViewSender = () => {
        window.hotelShowSenderHandle = typeof window.hotelShowSenderHandle === 'undefined' ? false : window.hotelShowSenderHandle;
        window.hotelShowList         = typeof window.hotelShowList === 'undefined' ? [] : window.hotelShowList;
        window.hotelShowListSended   = typeof window.hotelShowListSended === 'undefined' ? [] : window.hotelShowListSended;
        window.needToSend            = typeof window.needToSend === 'undefined' ? [] : window.needToSend;
    
        if (window.hotelShowList.length === 0 || window.hotelShowList.length === window.hotelShowListSended.length) {
            return false;
        }
    
        clearTimeout(window.hotelShowSenderHandle);
        window.hotelShowSenderHandle = setTimeout(function () {
            // смотрим что нужно отправить
            window.hotelShowList.forEach(function(id) {
                if (window.hotelShowListSended.indexOf(id) === -1) {
                    window.needToSend.push(id);
                }
            });
    
            // копируем массив
            window.hotelShowListSended = JSON.parse(JSON.stringify(window.hotelShowList));
    
            fetch('/hotels/increment_hotels_shows/', {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: obj.formData({
                    'hotel_list[]': window.needToSend,
                    'page_type_id': document.body.dataset.page_type_id || 0,
                }),
            });
    
            if (window.needToSend) {
                const ecommerceItems = [];
    
                [...window.needToSend].forEach(hotelID => {
                    const $cardData = document.querySelector('#hotel-' + hotelID + ' > script');
                    if ($cardData) {
                        let json;
    
                        try {
                            json = JSON.parse($cardData.innerHTML)
                        } catch(e) {
                            console.error(e);
                        }
    
                        if (json) {
                            ecommerceItems.push(json);
                        }
    
                        // вешаем событие на клик
                        const $card = document.querySelector('#hotel-' + hotelID);
                        if ($card && json) {
                            $card.addEventListener('click', (e) => {
                                YandexEcommerce.push('click', [json]);
                            });
                        }
                    }
                });
    
                if (ecommerceItems.length > 0) {
                    YandexEcommerce.push('impressions', ecommerceItems);
                }
            }
    
            window.needToSend = [];
        }, 1000);
    }

    /**
     * Добавляем обсерверы на отели
     */
    this.updateHotelViewObserver = () => {
        // поддержка обсерверов
        if (!obj.hasObserverSupport()) {
            return false;
        }
    
        window.hotelShowList = typeof window.hotelShowList === 'undefined' ? [] : window.hotelShowList;
    
        // обсервер для просмотров объектов
        const hotelViewObserver = new IntersectionObserver(function(entries) {
            let isFired = false;
            entries.forEach(function(item) {
                if (item.intersectionRatio > 0) {
                    let id = parseInt(item.target.dataset.id, 10);
                    if (window.hotelShowList.indexOf(id) === -1) {
                        window.hotelShowList.push(id);
                    }
                    isFired = true;
                }
            });
    
            // задачу на отправку
            if (isFired) {
                obj.hotelViewSender();
            }
        });
    
        const containerList = document.querySelectorAll('.js-objectFavorite:not(.js-hotelViewObserverInit)');
        for (var i = 0; i < containerList.length; i++) {
            containerList[i].classList.add('js-hotelViewObserverInit');
            hotelViewObserver.observe(containerList[i]);
        }
    }

    /**
     * Скрипт анимации прелоадера - логотипа
     */
    let svgPre = document.querySelectorAll('.js-preloadNew path:not(:first-child)');
    let arrOpacity = [];
    let intervalID = '';

    this.animateSvgPre = function(abort) {
        let i = 0;
        [].forEach.call(svgPre, function(el) {
            let x = el.getAttribute('fill-opacity');
            arrOpacity.push(x);
        });

        if(abort) {
            clearInterval(intervalID);
            return false;
        }

        intervalID = setInterval(function() {
            // Пересобираем массив
            arrOpacity = [arrOpacity[arrOpacity.length - 1], ...arrOpacity];
            delete arrOpacity[arrOpacity.length - 1];
            arrOpacity = arrOpacity.filter(function(index) {
                return index !== 'undefined';
            });

            arrOpacity.forEach(function(val) {
                svgPre[i].setAttribute('fill-opacity', val);

                i++;

                if (i == arrOpacity.length) {
                    i = 0;
                }
            });

        }, 130);
    }

    /**
     * Кроссбраузерная Функция для получения объекта глобальных координат отступа
     */
    this.getViewportOffset = function() {
        return {
            top: window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop,
            left: window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft
        };
    }

    /**
     * Аналог observer только нативный
     */
    this.isScrolledIntoView = (elem) => {
        const docViewTop = window.pageYOffset,
              docViewBottom = docViewTop + window.innerHeight,
              elemTop = elem.offsetTop,
              elemBottom = elemTop + elem.offsetHeight;
        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }

    /**
     * Установка фокуса на последний символ поля elem
     */
    this.setCaretAtEnd = function(elem) {
        var elemLen = elem.value.length;
        // For IE Only
        if (document.selection) {
            // Set focus
            elem.focus();
            // Use IE Ranges
            var oSel = document.selection.createRange();
            // Reset position to 0 & then set at end
            oSel.moveStart('character', -elemLen);
            oSel.moveStart('character', elemLen);
            oSel.moveEnd('character', 0);
            oSel.select();
        } else if (elem.selectionStart || elem.selectionStart == '0') {
            // Firefox/Chrome
            elem.selectionStart = elemLen;
            elem.selectionEnd = elemLen;
            elem.focus();
        }
    }

    /**
     * Вспомогательная функция для парсинга url
     */
    this.parseUrl = function() {
        let search = location.hash;
        let parse = {};

        if (search.length > 1) {
            search = search.replace('#', '');
            try {
              parse = JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g,'":"') + '"}', function(key, value) { return key===""?value:decodeURIComponent(value) })
            } catch(e) {
                // ignore
                parse = {}
            }
        }

        return parse;
    }

    /**
    *
    *  MD5 (Message-Digest Algorithm)
    *  http://www.webtoolkit.info/
    *
    **/
    this.md5 = function (string) {
        function RotateLeft(lValue, iShiftBits) {
            return (lValue<<iShiftBits) | (lValue>>>(32-iShiftBits));
        }

        function AddUnsigned(lX,lY) {
            var lX4,lY4,lX8,lY8,lResult;
            lX8 = (lX & 0x80000000);
            lY8 = (lY & 0x80000000);
            lX4 = (lX & 0x40000000);
            lY4 = (lY & 0x40000000);
            lResult = (lX & 0x3FFFFFFF)+(lY & 0x3FFFFFFF);
            if (lX4 & lY4) {
                return (lResult ^ 0x80000000 ^ lX8 ^ lY8);
            }
            if (lX4 | lY4) {
                if (lResult & 0x40000000) {
                    return (lResult ^ 0xC0000000 ^ lX8 ^ lY8);
                } else {
                    return (lResult ^ 0x40000000 ^ lX8 ^ lY8);
                }
            } else {
                return (lResult ^ lX8 ^ lY8);
            }
        }

        function F(x,y,z) { return (x & y) | ((~x) & z); }
        function G(x,y,z) { return (x & z) | (y & (~z)); }
        function H(x,y,z) { return (x ^ y ^ z); }
        function I(x,y,z) { return (y ^ (x | (~z))); }

        function FF(a,b,c,d,x,s,ac) {
            a = AddUnsigned(a, AddUnsigned(AddUnsigned(F(b, c, d), x), ac));
            return AddUnsigned(RotateLeft(a, s), b);
        };

        function GG(a,b,c,d,x,s,ac) {
            a = AddUnsigned(a, AddUnsigned(AddUnsigned(G(b, c, d), x), ac));
            return AddUnsigned(RotateLeft(a, s), b);
        };

        function HH(a,b,c,d,x,s,ac) {
            a = AddUnsigned(a, AddUnsigned(AddUnsigned(H(b, c, d), x), ac));
            return AddUnsigned(RotateLeft(a, s), b);
        };

        function II(a,b,c,d,x,s,ac) {
            a = AddUnsigned(a, AddUnsigned(AddUnsigned(I(b, c, d), x), ac));
            return AddUnsigned(RotateLeft(a, s), b);
        };

        function ConvertToWordArray(string) {
            var lWordCount;
            var lMessageLength = string.length;
            var lNumberOfWords_temp1=lMessageLength + 8;
            var lNumberOfWords_temp2=(lNumberOfWords_temp1-(lNumberOfWords_temp1 % 64))/64;
            var lNumberOfWords = (lNumberOfWords_temp2+1)*16;
            var lWordArray=Array(lNumberOfWords-1);
            var lBytePosition = 0;
            var lByteCount = 0;
            while ( lByteCount < lMessageLength ) {
                lWordCount = (lByteCount-(lByteCount % 4))/4;
                lBytePosition = (lByteCount % 4)*8;
                lWordArray[lWordCount] = (lWordArray[lWordCount] | (string.charCodeAt(lByteCount)<<lBytePosition));
                lByteCount++;
            }
            lWordCount = (lByteCount-(lByteCount % 4))/4;
            lBytePosition = (lByteCount % 4)*8;
            lWordArray[lWordCount] = lWordArray[lWordCount] | (0x80<<lBytePosition);
            lWordArray[lNumberOfWords-2] = lMessageLength<<3;
            lWordArray[lNumberOfWords-1] = lMessageLength>>>29;
            return lWordArray;
        };

        function WordToHex(lValue) {
            var WordToHexValue="",WordToHexValue_temp="",lByte,lCount;
            for (lCount = 0;lCount<=3;lCount++) {
                lByte = (lValue>>>(lCount*8)) & 255;
                WordToHexValue_temp = "0" + lByte.toString(16);
                WordToHexValue = WordToHexValue + WordToHexValue_temp.substr(WordToHexValue_temp.length-2,2);
            }
            return WordToHexValue;
        };

        function Utf8Encode(string) {
            string = string.replace(/\r\n/g,"\n");
            var utftext = "";

            for (var n = 0; n < string.length; n++) {

                var c = string.charCodeAt(n);

                if (c < 128) {
                    utftext += String.fromCharCode(c);
                }
                else if((c > 127) && (c < 2048)) {
                    utftext += String.fromCharCode((c >> 6) | 192);
                    utftext += String.fromCharCode((c & 63) | 128);
                }
                else {
                    utftext += String.fromCharCode((c >> 12) | 224);
                    utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                    utftext += String.fromCharCode((c & 63) | 128);
                }

            }

            return utftext;
        };

        var x=Array();
        var k,AA,BB,CC,DD,a,b,c,d;
        var S11=7, S12=12, S13=17, S14=22;
        var S21=5, S22=9 , S23=14, S24=20;
        var S31=4, S32=11, S33=16, S34=23;
        var S41=6, S42=10, S43=15, S44=21;

        string = Utf8Encode(string);

        x = ConvertToWordArray(string);

        a = 0x67452301; b = 0xEFCDAB89; c = 0x98BADCFE; d = 0x10325476;

        for (k=0;k<x.length;k+=16) {
            AA=a; BB=b; CC=c; DD=d;
            a=FF(a,b,c,d,x[k+0], S11,0xD76AA478);
            d=FF(d,a,b,c,x[k+1], S12,0xE8C7B756);
            c=FF(c,d,a,b,x[k+2], S13,0x242070DB);
            b=FF(b,c,d,a,x[k+3], S14,0xC1BDCEEE);
            a=FF(a,b,c,d,x[k+4], S11,0xF57C0FAF);
            d=FF(d,a,b,c,x[k+5], S12,0x4787C62A);
            c=FF(c,d,a,b,x[k+6], S13,0xA8304613);
            b=FF(b,c,d,a,x[k+7], S14,0xFD469501);
            a=FF(a,b,c,d,x[k+8], S11,0x698098D8);
            d=FF(d,a,b,c,x[k+9], S12,0x8B44F7AF);
            c=FF(c,d,a,b,x[k+10],S13,0xFFFF5BB1);
            b=FF(b,c,d,a,x[k+11],S14,0x895CD7BE);
            a=FF(a,b,c,d,x[k+12],S11,0x6B901122);
            d=FF(d,a,b,c,x[k+13],S12,0xFD987193);
            c=FF(c,d,a,b,x[k+14],S13,0xA679438E);
            b=FF(b,c,d,a,x[k+15],S14,0x49B40821);
            a=GG(a,b,c,d,x[k+1], S21,0xF61E2562);
            d=GG(d,a,b,c,x[k+6], S22,0xC040B340);
            c=GG(c,d,a,b,x[k+11],S23,0x265E5A51);
            b=GG(b,c,d,a,x[k+0], S24,0xE9B6C7AA);
            a=GG(a,b,c,d,x[k+5], S21,0xD62F105D);
            d=GG(d,a,b,c,x[k+10],S22,0x2441453);
            c=GG(c,d,a,b,x[k+15],S23,0xD8A1E681);
            b=GG(b,c,d,a,x[k+4], S24,0xE7D3FBC8);
            a=GG(a,b,c,d,x[k+9], S21,0x21E1CDE6);
            d=GG(d,a,b,c,x[k+14],S22,0xC33707D6);
            c=GG(c,d,a,b,x[k+3], S23,0xF4D50D87);
            b=GG(b,c,d,a,x[k+8], S24,0x455A14ED);
            a=GG(a,b,c,d,x[k+13],S21,0xA9E3E905);
            d=GG(d,a,b,c,x[k+2], S22,0xFCEFA3F8);
            c=GG(c,d,a,b,x[k+7], S23,0x676F02D9);
            b=GG(b,c,d,a,x[k+12],S24,0x8D2A4C8A);
            a=HH(a,b,c,d,x[k+5], S31,0xFFFA3942);
            d=HH(d,a,b,c,x[k+8], S32,0x8771F681);
            c=HH(c,d,a,b,x[k+11],S33,0x6D9D6122);
            b=HH(b,c,d,a,x[k+14],S34,0xFDE5380C);
            a=HH(a,b,c,d,x[k+1], S31,0xA4BEEA44);
            d=HH(d,a,b,c,x[k+4], S32,0x4BDECFA9);
            c=HH(c,d,a,b,x[k+7], S33,0xF6BB4B60);
            b=HH(b,c,d,a,x[k+10],S34,0xBEBFBC70);
            a=HH(a,b,c,d,x[k+13],S31,0x289B7EC6);
            d=HH(d,a,b,c,x[k+0], S32,0xEAA127FA);
            c=HH(c,d,a,b,x[k+3], S33,0xD4EF3085);
            b=HH(b,c,d,a,x[k+6], S34,0x4881D05);
            a=HH(a,b,c,d,x[k+9], S31,0xD9D4D039);
            d=HH(d,a,b,c,x[k+12],S32,0xE6DB99E5);
            c=HH(c,d,a,b,x[k+15],S33,0x1FA27CF8);
            b=HH(b,c,d,a,x[k+2], S34,0xC4AC5665);
            a=II(a,b,c,d,x[k+0], S41,0xF4292244);
            d=II(d,a,b,c,x[k+7], S42,0x432AFF97);
            c=II(c,d,a,b,x[k+14],S43,0xAB9423A7);
            b=II(b,c,d,a,x[k+5], S44,0xFC93A039);
            a=II(a,b,c,d,x[k+12],S41,0x655B59C3);
            d=II(d,a,b,c,x[k+3], S42,0x8F0CCC92);
            c=II(c,d,a,b,x[k+10],S43,0xFFEFF47D);
            b=II(b,c,d,a,x[k+1], S44,0x85845DD1);
            a=II(a,b,c,d,x[k+8], S41,0x6FA87E4F);
            d=II(d,a,b,c,x[k+15],S42,0xFE2CE6E0);
            c=II(c,d,a,b,x[k+6], S43,0xA3014314);
            b=II(b,c,d,a,x[k+13],S44,0x4E0811A1);
            a=II(a,b,c,d,x[k+4], S41,0xF7537E82);
            d=II(d,a,b,c,x[k+11],S42,0xBD3AF235);
            c=II(c,d,a,b,x[k+2], S43,0x2AD7D2BB);
            b=II(b,c,d,a,x[k+9], S44,0xEB86D391);
            a=AddUnsigned(a,AA);
            b=AddUnsigned(b,BB);
            c=AddUnsigned(c,CC);
            d=AddUnsigned(d,DD);
        }

        var temp = WordToHex(a)+WordToHex(b)+WordToHex(c)+WordToHex(d);

        return temp.toLowerCase();
    }

    this.consoleTime = function(label) {
        if (obj.hasDebug()) {
            console.time(label);
        }
    }

    this.consoleTimeEnd = function(label) {
        if (obj.hasDebug()) {
            console.timeEnd(label);
        }
    }

    /**
     * Функция склонения
     */
    this.declension = function(count, f1, f24, f50) {
        count = parseInt(count);
        if(count > 10 && count < 20) {
            return f50;
        }
        if(count % 10 == 1) {
            return f1;
        }
        if(count % 10 == 2 || count % 10 == 3 || count % 10 == 4) {
            return f24;
        }
        return f50;
    }

    /**
     * Загружаем первые фотки для скелета
     */
    this.loadFirstImages = function($hotel_list, deferredCount = 6) {
        return new Promise((resolve, reject) => {
            // контейнер пуст или кол-во объектов не указано
            if (!$hotel_list || deferredCount <= 0) {
                return resolve(false);
            }

            // контейнеры для фотогалереи карточек
            const $photoContainers = $hotel_list.querySelectorAll('.js-photoContainer');
            if ($photoContainers.length) {
                return resolve(false);
            }
            
            // кол-во объектов на странице может быть меньше deferredCount
            if ($photoContainers.length < deferredCount) {
                deferredCount = $photoContainers.length;
            }

            const count = deferredCount;
            for (var i = 0; i < count; i++) {
                console.log($photoContainers[i]);
                const json = $photoContainers[i].getAttribute('data-photo-json');
    
                // нет данных
                if (typeof json === 'undefined' || $photoContainer.length === 0 ||
                    typeof json[0] === 'undefined' || typeof json[0]['photo'] === 'undefined') {
                    continue;
                }

                const src        = json[0]['photo']; 
                const $imageItem = $photoContainer.querySelector('.js-image');

                obj.loadImage(src).then(() => {
                    $imageItem.css('background-image', 'url(' + src + ')');
                    deferredCount--;
                    if (deferredCount === 0) {
                        resolve(true);
                    }
                });
            }
        });
    }

    /**
     * Загрузка изображений
     * Возвращает Promise, который срабатывает, после загрузки фото
     */
    this.loadImage = function(src) {
        return new Promise((resolve, reject) => {
            const image = new Image();
    
            // повторное обращение
            if (obj.page.images.hasOwnProperty(src)) {
                return resolve();
            }
    
            // фотка успешно загружена
            image.onload = function(e) {
                resolve();
                obj.page.images[src] = image;
            };
    
            // ошибка
            image.onerror = function(e) {
                resolve();
                obj.page.images[src] = image;
            };
    
            image.src = src;
        });
    }

    /**
     * Загрузка всех изображений
     * Возвращает Promise, который срабатывает, после загрузки всех фото
     */
    this.loadImages = (srcList) => {
        if (!srcList || !Array.isArray(srcList)) {
            return;
        }
    
        let count = srcList.length;
    
        return new Promise((resolve, reject) => {
            srcList.forEach(item => {
                let img     = new Image();
                img.onload  = () => {
                    count--;
                    if (count === 0) {
                        resolve();
                    }
                };
                img.onerror = (err) => console.log(err);
                img.src     = item['photo'];
            });
        });
    }

    /**
     * detect if localStorage is supported
     */
    this.checkLocalStorage = function() {
        let mod = '1';
        try {
            localStorage.setItem(mod, mod);
            localStorage.removeItem(mod);
            return true;
        } catch(e) {
            return false;
        }
    }

    /**
     * Задержка для callback, чтобы не спамить запросами
     */
    this.delay = (callback, ms) => {
        window.delayTimer = typeof window.delayTimer === 'undefined' ? 0 : window.delayTimer;
        clearTimeout(window.delayTimer);
        window.delayTimer = setTimeout(function() {
            callback();
        }, ms || 0);
    }

    /**
     * Мобилка?
     * @return {Boolean} true если да
     */
    this.isMobile = function() {
        return window.innerWidth <= 959;
    }

    /**
     * Запуск таймера, исправляющего (помогающего исправлять) поведение страниц на некоторых браузерах
     */
    this.initFallbackStyles = function() {
        // принудительный пересчёт высоты экрана
        setInterval(function() {
            const vh = parseFloat((window.innerHeight * 0.01).toFixed(2));
            if (vh != parseFloat(document.documentElement.style.getPropertyValue('--vh'))) {
                document.documentElement.style.setProperty('--vh', vh + 'px');
            }
        }, 100);
    }
}

// возвращаем класс
export default (
    typeof window.utils === 'undefined'
        ? window.utils = new Utils()
        : window.utils
);
